export const DECODE_SECURITY_TOKEN = 'DECODE_SECURITY_TOKEN';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const SET_LOGGED_IN = 'SET_LOGGEDIN_IN';
